export const TIMEOUT = 1000;
export const INSIDER_URL = '//tigerone.api.useinsider.com/ins.js?id=10007716';
